<template>
    <select class="LpCareerSelect2 form-control">
        <option value="" v-if="isMultiple"></option>
    </select>
</template>

<script>
    export default {
        props: ['options', 'modelValue', 'isMultiple'],
        props: {
            options: Array,
            modelValue: [String, Array],
            isMultiple: {
                type: Boolean,
                default: false
            }
        },
        mounted: function () {

          var vm = this;
          $(this.$el)
            // init select2
            .select2({ 
                data: this.options.map(item => { return { id: item.Id, text: item.Text } }),
                language: 'cs',
                width: '100%',
                tags: false,
                theme: 'LpCareerSelect2Js',
                allowClear: !vm.isMultiple,
                multiple: vm.isMultiple
            })
            .val(this.modelValue)
            .trigger("change")
            // emit event on change.
            .on("change", function (event) {
              if ( vm.isMultiple ) {
                vm.$emit("update:modelValue", Array.from(event.target.selectedOptions).map(({ value }) => value));
              }
              else
              {
                  vm.$emit("update:modelValue", event.target.value);
              }
            });

        },
        watch: {
            modelValue: function (value) {
                // update value
                // avoid endless reccursion with change handler
                let didChange = false;

                if ( this.isMultiple ) {
                    if ( $(this.$el).val().toString() !== value.toString() ) {
                        didChange = true;
                    }
                }
                else
                {
                    if ( $(this.$el).val() !== value ) {
                        didChange = true;
                    }
                }

                if ( didChange ) {
                    $(this.$el).val(value).trigger("change");
                }
            },
            options: function (options) {
                // update options
                $(this.$el).empty().select2({ data: options });
            }
        },
        destroyed: function () {
            $(this.$el).off().select2("destroy");
        }
    }
</script>